import api from "./core";

const basePath = "api/core/Audit";

export default {
  queryAuth(filter) {
    return api.post(`${basePath}/QueryAuth`, filter);
  },

  queryHistory(filter) {
    return api.post(`${basePath}/QueryHistory`, filter);
  },

  findUsers(filter) {
    return api.post(`${basePath}/FindUsers`, filter);
  },

  findLocations(filter) {
    return api.post(`${basePath}/FindLocations`, filter);
  }
};
